import React from 'react';
import { ReactComponent as Close } from '../assets/custom/icons/ex.svg';
import useStore from '@data/state/zustand';
var modalContent = null; //react component placeholder!!!

export function setModalContent(content, header, showBottomCloseButton = true, width = 'modal-lg', modalParams = {}) {
    modalContent = content;
    useStore.getState().setNestedProperty(['modalData'], {
        display: true,
        header,
        showBottomCloseButton,
        width,
        params: modalParams,
    });
}

export function closeModal() {
    modalContent = null;
    useStore.getState().setNestedProperty(['modalData'], { display: false });
    // useStore.getState().setNestedProperty(['modalData'], { display: false });
}

function MainModal() {
    const data = useStore((appState) => appState.modalData);
    const { display, width, header, showBottomCloseButton } = data;
    const style = display === true ? { display: 'block', overflowY: 'auto' } : { display: 'none' };

    const modalOverlayStyle = {
        position: 'fixed' /* Sit on top of the page content */,
        display: 'none' /* Hidden by default, but will be overwritten dynamicly */,
        width: '100%' /* Full width (cover the whole page) */,
        height: '100%' /* Full height (cover the whole page) */,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.5)' /* Black background with opacity */,
        zIndex: 10000 /* Specify a stack order in case you're using a different order for other elements */,
    };

    return (
        <div style={{ ...modalOverlayStyle, ...style }}>
            <div className="modal fade show" id="mainModal" tabIndex="-1" style={style}>
                <div className={'modal-dialog ' + width}>
                    <div className="modal-content">
                        {header ? (
                            <div className="modal-header pointer">
                                <h5 className="modal-title">{header}</h5>
                                {/* <button type="button" className="close" onClick={closeModal}>
                                    <span aria-hidden="true">&times;</span>
                                </button> */}
                                <Close onClick={closeModal} />
                            </div>
                        ) : null}

                        <div className="modal-body">{modalContent}</div>

                        {showBottomCloseButton ? (
                            <div className="modal-footer">
                                <button onClick={closeModal} type="button" className="button-secondary">
                                    {window.translate('Close')}
                                </button>{' '}
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    );
}

export function showConfirmationModal(props) {
    const { title = 'title', callback = () => {} } = props; //defaults are here
    setModalContent(
        <div className="container-fluid">
            <div className="text-center">
                {window.translate('Please confirm.')}
                <hr />
            </div>

            <div className="text-center">
                <button
                    onClick={async () => {
                        callback();
                        closeModal();
                    }}
                    className="btn btn-sm btn-outline-primary mr-2"
                >
                    {window.translate('Confirm')}
                </button>

                <button
                    onClick={() => {
                        closeModal();
                    }}
                    className="btn btn-sm btn-outline-secondary"
                >
                    {window.translate('Cancel')}
                </button>
            </div>
        </div>,

        title, // header
        false, // showCloseButton
        'modal-md'
    );
}

export default MainModal;
